import React, { useState, useEffect } from 'react';
import { animated, useSpring } from '@react-spring/web';

import Appearance from 'styles/Appearance.js';
import Banner from 'views/Banner.js';

const BannerStack = ({ banners, onClose, utils }) => {

    const [animations, animationsApi] = useSpring(() => ({
        config: { mass: 1, tension: 180, friction: 16 },
        opacity: 0
    }));
    const [visible, setVisible] = useState(false);

    const onCloseBanner = banner => {

        // notify sender the banner closed if applciable
        if(typeof(banner.onClose) === 'function') {
            banner.onClose();
        }

        // notify subscribers that banners have changed
        onClose(banner.id);
    }
    
    const show = () => {
        setVisible(true);
        animationsApi.start({
            delay: 100,
            to: async next => {
                await next({ opacity: 1 });
            }
        });
    }
    
    const hide = () => {
        animationsApi({
            to: async next => {
                await next({ opacity: 0 });
                setVisible(false);
            }
        });
    }

    useEffect(() => {
        banners.length > 0 ? show() : hide();
    }, [banners]);

    return visible && (
        <animated.div style={{
            backgroundColor: Appearance.colors.transparent,
            inset: 0,
            left: 0,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 32,
            pointerEvents: 'none',
            position: 'fixed',
            right: 0,
            top: 0,
            zIndex: 9500,
            ...animations
        }}>
            <div style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                pointerEvents: 'none',
                position: 'relative',
                width: '100%'
            }}>
                {banners.map((banner, index) => (
                    <Banner
                    {...banner}
                    key={banner.id}
                    index={(banners.length - 1) - index}
                    onClose={onCloseBanner.bind(this, banner)} 
                    orderIndex={index}
                    utils={utils} />
                ))}
            </div>
        </animated.div>
    );
}
export default BannerStack;
